import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0248 6.65388L8.22727 11.4514C7.92424 11.7544 7.92424 12.2457 8.22727 12.5487L13.0248 17.3462C13.5136 17.835 14.3494 17.4888 14.3494 16.7975V7.20256C14.3494 6.51126 13.5136 6.16505 13.0248 6.65388Z",
		fill: "currentColor"
	})
});
export default SvgCaretLeft;
